export const exportCsv = (dataObj: any[], labels: string[], fileName: string) => {
  const csvDataLabels = `${labels}\n`;
  const deviceLocationStrings: string = dataObj.map((row: any) => Object.values(row).join(",")).join("\n");

  const hiddenElement = document.createElement("a");

  hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csvDataLabels + deviceLocationStrings)}`;
  hiddenElement.target = "_blank";
  hiddenElement.download = fileName;
  hiddenElement.click();
};

export const exportDeviceSampleCsv = (dataObj: any[], labels: string[]) => {
  const csvDataLabels = `${labels}\n`;
  const tab = "\t";

  // Get headers from the first object
  const headers = Object.keys(dataObj[0]);

  // Map objects to arrays of values
  const rows = dataObj.map((data) => headers.map((header) => data[header]));

  const csvString = [...rows].map((row) => row.join(",")).join("\n");

  const lines = csvString.split("\n");

  const modifiiedLines = lines.map((line: any) => {
    const columns = line.split(",");
    const modifiedColumns = columns.map((column: any) => tab + column.trim()); // .trim() removes any existing leading/trailing whitespace
    return modifiedColumns.join(",");
  });
  // addes a tab to each value. chantes excel column format to a string value
  const valuesToAdd = Array.from({ length: 98 }, (_) => `${tab},${tab}`);

  modifiiedLines.push(...valuesToAdd);
  const joinedLines = modifiiedLines.join("\n");

  const hiddenElement = document.createElement("a");
  hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csvDataLabels + joinedLines)}`;
  hiddenElement.target = "_blank";
  hiddenElement.download = `MegaFi_Device_Import_Sample.csv`;
  hiddenElement.click();
};
